export default __webpack_public_path__ + "static/media/Europes Leading Destination 2017-2020.4a40a684.svg";